// extracted by mini-css-extract-plugin
export default {"placeholder":"jvXsz","bottomSheet":"sHblR","animated":"UKQJd","handle":"dIHCX","line":"Kt9yP","body":"xNIEc","draggableContainer":"FqNaZ","expanded":"Acbqh","unscrollable":"cIkGn"};